/** Keep in sync with `queryKeys.helcimCardsOnFile.root` in dashboard react-query constants. */
export const HELCIM_CARDS_ON_FILE_QUERY_ROOT = 'helcimCardsOnFile' as const;

export function helcimCardsOnFileQueryKey(userId: number) {
  return [HELCIM_CARDS_ON_FILE_QUERY_ROOT, userId] as const;
}

/** Keep in sync with `queryKeys.helcimCardLink.root` in dashboard react-query constants. */
export const HELCIM_CARD_LINK_QUERY_ROOT = 'helcimCardLink' as const;

export function helcimCardLinkQueryKey(userId: number) {
  return [HELCIM_CARD_LINK_QUERY_ROOT, userId] as const;
}

export const HELCIM_CARD_AUDIT_QUERY_ROOT = 'helcimCardAudit' as const;

export function helcimCardAuditQueryKey(userId: number) {
  return [HELCIM_CARD_AUDIT_QUERY_ROOT, userId] as const;
}

export const CARD_ON_FILE_ACTORS_QUERY_ROOT = 'cardOnFileActors' as const;

export function cardOnFileActorsQueryKey(actorIds: readonly number[]) {
  return [CARD_ON_FILE_ACTORS_QUERY_ROOT, actorIds.join(',')] as const;
}
